import { Action } from 'redux-actions';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import { APIConfiguration } from '@savgroup-front-common/configuration';
import { logCritical } from '@savgroup-front-common/configuration/src/appInsights/AppInsights';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/src/shared';

import callAndGetResponse from '../../services/callAndGetResponse';
import { Selectors as requestSelectors } from '../sagaRequestMetadata';

import * as types from './actionTypes';

function* getSellerWorker({
  payload: { forceRefresh = false },
}: {
  payload: { forceRefresh?: boolean };
}): Generator {
  const wasLoaded = yield select((state) =>
    requestSelectors.wasActionLoadedSelector(state, types.GET_SELLER),
  );

  if (!wasLoaded || forceRefresh) {
    yield call(
      callAndGetResponse,
      types.GET_SELLER,
      `${APIConfiguration.config}user/sellers`,
      { method: SUPPORTED_METHODS.GET },
      {},
    );
  }

  yield put(types.GET_SELLER.end());
}
function* getSellerWatcher() {
  yield takeEvery<Action<{ forceRefresh: boolean }>>(
    types.GET_SELLER.BASE,
    getSellerWorker,
  );
}

export default function* sellerSaga(): Generator {
  try {
    yield all([getSellerWatcher()]);
  } catch (error) {
    logCritical(error as any);
  }
}
